import api from '@/common/api';
import { ADMIN } from '@/common/constants/userTypes';

// Справочник тегов корпоративных клиентов (виден только администратору).
// Права отдельным флагом не приходят: ответ 403 справочника означает «нет доступа», тогда теги и управление скрыты.
const ENDPOINT = '/users/corp_client_tags/';
// Номер последней загрузки: ответ устаревшей загрузки (после правки справочника уже пошла новая) не применяем
let lastLoadId = 0;

const initialState = () => ({
  tags: [],
  loading: false,
  loaded: false,
  // Справочник ответил 403: у пользователя нет доступа к тегам
  forbidden: false,
  error: false,
});

export default {
  namespaced: true,
  state: initialState,
  getters: {
    tags: (state) => state.tags,
    loading: (state) => state.loading,
    loaded: (state) => state.loaded,
    forbidden: (state) => state.forbidden,
    error: (state) => state.error,
    // Управление тегами: справочник хоть раз загружен, не ответил 403 и текущий пользователь — админ.
    // Сбой повторной загрузки интерфейс не прячет: остаётся прежний список, ошибку видно в getter error.
    available: (state, getters, rootState, rootGetters) => {
      const user = rootGetters['auth/user'];
      return state.loaded && !state.forbidden && !!user && user.user_type === ADMIN;
    },
  },
  actions: {
    // Список без пагинации (page_size=-1), отсортирован сервером по названию
    async load({ commit }) {
      lastLoadId += 1;
      const loadId = lastLoadId;
      commit('loadRequest');
      try {
        const response = await api.get(ENDPOINT, { params: { page_size: -1 } });
        if (loadId !== lastLoadId) return;
        commit('loadSuccess', Array.isArray(response) ? response : (response.results || []));
      } catch (err) {
        if (loadId !== lastLoadId) return;
        commit('loadFailure', err && err.status === 403);
      }
    },
    // Грузит справочник, если его ещё нет или прошлая загрузка закончилась ошибкой
    async ensureLoaded({ dispatch, state }) {
      if (state.loading || state.forbidden || (state.loaded && !state.error)) return;
      await dispatch('load');
    },
    // Ошибки валидации (400) пробрасываем в компонент: их показывают рядом с полем
    async create({ dispatch }, name) {
      const tag = await api.post(ENDPOINT, { name });
      await dispatch('load');
      return tag;
    },
    async rename({ dispatch }, { id, name }) {
      const tag = await api.patch(`${ENDPOINT}${id}/`, { name });
      await dispatch('load');
      return tag;
    },
    async remove({ dispatch }, id) {
      await api.delete(`${ENDPOINT}${id}/`);
      await dispatch('load');
    },
    reset({ commit }) {
      commit('reset');
    },
  },
  mutations: {
    loadRequest(state) {
      state.loading = true;
      state.error = false;
    },
    loadSuccess(state, tags) {
      state.tags = tags;
      state.loading = false;
      state.loaded = true;
      state.forbidden = false;
    },
    loadFailure(state, forbidden) {
      state.loading = false;
      state.forbidden = !!forbidden;
      state.error = !forbidden;
      // «Загружен» только при ответе сервера о доступе: при сбое сети следующая попытка повторит загрузку
      if (forbidden) state.loaded = true;
    },
    reset(state) {
      Object.assign(state, initialState());
    },
  },
};
